import {Icon, ToolbarIcons} from '@priority-software/priority-style-react';
import React, {FC, ReactNode, useMemo} from 'react';
import {emailDialogID} from '../testIDs';
import {ModernTooltip} from '../../../components/Common/Tooltip/ModernTooltip';
import {createDataTestId} from '../../../utils/dataTestId';
import {useEmailContext} from '../context';

type TIconWithPopover = {content: ReactNode} & (
    | {type: 'children'; children: ReactNode}
    | {
          type: 'icon';
          icon?: ToolbarIcons;
          onClick: (e) => void;
          content: ReactNode;
          componentClasses?: string;
      }
);

export const IconWithPopover: FC<TIconWithPopover> = props => {
    const {states} = useEmailContext();
    const disabled = useMemo(() => states.focusSubject, [states.focusSubject]);

    let Component: ReactNode;

    if (props.type === 'children') {
        Component = props.children;
    } else {
        const {icon, onClick, componentClasses} = props;

        Component = (
            <Icon
                {...{
                    ...createDataTestId(`toolbar-${icon}-icon`, true),
                    onClick: disabled ? undefined : onClick,
                    icon,
                    componentClasses: disabled
                        ? null
                        : componentClasses ?? 'priority-editor__toolbar-item',
                    style: {
                        userSelect: 'none',
                        cursor: disabled ? 'unset' : 'pointer',
                        ...(disabled && {
                            padding: 8
                        })
                    },
                    iconColor: disabled ? 'secondary-300' : 'primary-700'
                }}
            />
        );
    }

    return (
        <ModernTooltip
            {...createDataTestId(`email-toolbar-tooltip`, true)}
            tooltip={props.content}
            maxWidth={400}
            position="top"
            tooltipOffset={8}
            portalId={emailDialogID}
        >
            {Component}
        </ModernTooltip>
    );
};
